import React from 'react';
import './PageHeader.scss';
import Title from 'antd/lib/typography/Title';

interface PageHeaderProps {
  title?: string;
}

const PageHeader = (props: PageHeaderProps): JSX.Element => {
  return (
    <div className="pageHeader">
      <div className="pageHeader-box">
        {props.title && <Title level={2}>{props.title}</Title>}
      </div>
    </div>
  );
};

export default PageHeader;
